export default {"src":"/_next/static/media/thunder.fb7b208a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};